import '../httpservices/core/ajax.httpservice.core';

class MessageToHelpDeskHttpService {

    ContactUsMessageToHelpDesk(model) {
        return $.post('Public/ContactUsMessageToHelpDesk', model);
    }
}

export const MessageToHelpDeskHttpSvc = new MessageToHelpDeskHttpService();